var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenedEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616 1014 c-11 -11 -16 -35 -16 -80 0 -35 -2 -64 -4 -64 -26 0 -163 -33 -203 -49 l-52 -20 -33 56 c-39 66 -60 83 -85 67 -29 -18 -26 -38 11 -99 l35 -58 -100 -95 c-97 -92 -111 -116 -87 -140 22 -22 40 -12 128 71 101 97 193 147 312 171 97 20 139 20 236 0 119 -24 211 -74 312 -171 88 -83 106 -93 128 -71 24 24 10 48 -87 140 l-100 95 35 58 c37 61 40 81 12 99 -26 16 -47 -1 -86 -67 l-33 -56 -52 20 c-40 16 -177 49 -203 49 -2 0 -4 29 -4 64 0 62 -14 96 -40 96 -5 0 -16 -7 -24 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 695 c-63 -20 -126 -84 -145 -148 -19 -63 -19 -71 0 -134 32 -106 152 -179 257 -154 92 21 158 87 179 178 25 107 -46 226 -154 258 -61 18 -78 18 -137 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedEye);
export default __webpack_public_path__ + "static/media/opened-eye.00d755b826b344284ac48567f48af299.svg";
export { ForwardRef as ReactComponent };